export const LOAD_FIAS_UPDATES_START = 'react/fiasUpdates/LOAD_FIAS_UPDATES_START';
export const LOAD_FIAS_UPDATES_COMPLETE = 'react/fiasUpdates/LOAD_FIAS_UPDATES_COMPLETE';
export const LOAD_FIAS_UPDATES_ERROR = 'react/fiasUpdates/LOAD_FIAS_UPDATES_ERROR';

export const FIAS_UPDATES_DESTROY = 'react/fiasUpdates/FIAS_UPDATES_DESTROY';

const initialState = {
  loading: false,
  list: []
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_FIAS_UPDATES_COMPLETE:
      return {
        ...state,
        list: action.result,
        loading: false
      };
    case LOAD_FIAS_UPDATES_START:
      return {
        ...state,
        loading: true
      };
    case FIAS_UPDATES_DESTROY:
      return initialState;
    default:
      return state;
  }
}

export function loadFiasUpdates() {
  return {
    types: [LOAD_FIAS_UPDATES_START, LOAD_FIAS_UPDATES_COMPLETE, LOAD_FIAS_UPDATES_ERROR],
    promise: (client) => client.get('/api/fiasUpdates')
  };
}


export function destroyFiasUpdates() {
  return { type: FIAS_UPDATES_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/fiasUpdates/fiasUpdates.js